import { BLACK_d } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 4.6rem;
  border-top: 1px solid #363636;
  border-bottom: 1px solid #363636;
  display: flex;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 2rem;
    width: 100vw;
    margin-left: -20px;
    flex-direction: column;
  }
`;

export const NavWrapper = styled.div`
  width: 14rem;
  border-right: 1px solid #363636;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    border-right: none;
    min-width: 100%;
    padding-right: 2rem;
    border-bottom: 1px solid #363636;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 106rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  height: 8.4rem;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 3.2rem;
  padding: 0 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #363636;
  cursor: pointer;
  &:last-child {
    border: none;
  }

  & > img {
    width: 2.4rem;
    height: 2.4rem;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    border-right: none;
    width: 100%;
    font-size: 1.6rem;
    line-height: 2.8rem;
    height: 6.8rem;
    & > img {
      width: 1.6rem;
      height: 1.6rem;
    }
  }
`;

export const ExtraExplain = styled.div`
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.8rem;
  color: ${BLACK_d};
  padding: 3rem;
  background-color: black;
  border-bottom: 1px solid #363636;
  display: ${(props) => (props.isOpen ? "black" : "none")};

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 1.4rem;
    line-height: 2.4rem;
    padding: 1.5rem 2rem;
  }
`;
